import PageHeader from '@app/components/Layout/PageHeader';
import useInvoiceFormPageStore from './hooks/usePageStore';
import { useInvoiceFormListQuery } from './hooks/usePageQuery';
import InvoiceFormFilter from './components/Filter';
import InvoiceFormList from './components/ListView';
import InvoiceFormUpdatePopup from './components/UpdatePopup';

const InvoiceFormPage = () => {
    const { filterParams } = useInvoiceFormPageStore();

    const { data: apiData, isLoading } = useInvoiceFormListQuery(filterParams);

    const list = apiData?.list || [];
    const total = apiData?.total || 0;

    return (
        <>
            <PageHeader pageTitle="Mẫu hóa đơn" />
            <div className="content">
                <InvoiceFormFilter />
                <InvoiceFormList
                    list={list}
                    total={total}
                    isLoading={isLoading}
                />
            </div>
            <InvoiceFormUpdatePopup />
        </>
    );
};

export default InvoiceFormPage;
